import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function IsLoggedin({ children }) {
  const { isLoggedIn, isLoading } = useContext(AuthContext);
  const { t } = useTranslation();

  // If the authentication is still loading
  if (isLoading) return <p>{t("common.loading", { defaultValue: "Loading..." })}</p>;

  if (isLoggedIn) {
    // If the user is logged in
    return <Navigate to="/welcome" replace />;
  } else {
    // If the user is not logged in, allow to see the page
    return children;
  }
}

export default IsLoggedin;
